import { render, staticRenderFns } from "./SpecialTem.vue?vue&type=template&id=1ce12e22&scoped=true"
import script from "./SpecialTem.vue?vue&type=script&lang=js"
export * from "./SpecialTem.vue?vue&type=script&lang=js"
import style0 from "./SpecialTem.vue?vue&type=style&index=0&id=1ce12e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce12e22",
  null
  
)

export default component.exports